import { useMemo, useCallback } from 'react';
import { BudgetRecipientEnum } from '../types';
import { BudgetStatusEnum } from '../../../../enums/budgetStatus';

interface IUseConsultantJourneyParams {
  isEditMode: boolean;
  profile?: BudgetRecipientEnum;
  recipient?: string;
  status?: BudgetStatusEnum;
  orcamentoStatus?: BudgetStatusEnum;
}

export const useConsultantJourney = (params: IUseConsultantJourneyParams) => {
  const { isEditMode, profile, recipient, status, orcamentoStatus } = params;

  const isConsultant = profile === BudgetRecipientEnum.CONSULTANT;

  const isEditingRejected = useMemo(() => {
    const isRejected =
      orcamentoStatus === BudgetStatusEnum.REJECTED || status === BudgetStatusEnum.REJECTED;
    return isEditMode && isRejected && isConsultant;
  }, [isEditMode, orcamentoStatus, status, isConsultant]);

  const shouldDisableRecipient = useMemo(() => {
    return isEditingRejected;
  }, [isEditingRejected]);

  const getRecipientOptions = useCallback(
    (allOptions: Array<{ id: string; label: string }>) => {
      if (isEditMode && recipient === BudgetRecipientEnum.MANAGER) {
        return allOptions.filter((option) => option.id === BudgetRecipientEnum.MANAGER);
      }

      return allOptions.filter((option) => option.id !== profile);
    },
    [profile, isEditMode, recipient],
  );

  const getButtonLabel = useCallback(
    (
      isEditMode: boolean,
      counterProposal: boolean,
      counterProposalValue?: number,
    ): string => {
      if (isEditingRejected) {
        return 'Enviar orçamento';
      }

      if (
        isEditMode &&
        counterProposal &&
        counterProposalValue !== undefined &&
        counterProposalValue > 0
      ) {
        return 'Aceitar alterações e enviar';
      }

      return isEditMode ? 'Enviar alterações' : 'Enviar orçamento';
    },
    [isEditingRejected],
  );

  const shouldShowRejectionSection = useMemo(() => {
    if (
      orcamentoStatus !== BudgetStatusEnum.PENDING &&
      status !== BudgetStatusEnum.PENDING
    ) {
      if (
        isEditMode &&
        (orcamentoStatus === BudgetStatusEnum.REJECTED ||
          status === BudgetStatusEnum.REJECTED) &&
        (recipient === BudgetRecipientEnum.MANAGER ||
          (recipient === BudgetRecipientEnum.CONSULTANT && isConsultant))
      ) {
        return false;
      }
      return true;
    }
    return false;
  }, [orcamentoStatus, status, isEditMode, recipient, isConsultant]);

  return {
    isConsultant,
    isEditingRejected,
    shouldDisableRecipient,
    getRecipientOptions,
    getButtonLabel,
    shouldShowRejectionSection,
  };
};

